import { Card, Typography, Stack, tokens } from '@cast/design-system';

import type { StackProps } from '@cast/design-system';

type Props = {
  title?: string;
  headerAction?: React.ReactNode;
  children: React.ReactNode;
  contentWrapperProps?: StackProps;
  testId?: string;
};

export const Section = ({
  title,
  headerAction,
  children,
  contentWrapperProps,
  testId,
}: Props) => {
  return (
    <Stack gap={8} data-testid={testId}>
      {(title || headerAction) && (
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          {title && (
            <Typography
              variant="A2"
              color={tokens.theme.fg.structural.secondary}
            >
              {title}
            </Typography>
          )}
          {headerAction}
        </Stack>
      )}
      <Card sx={{ p: 16 }}>
        <Stack gap={16} {...contentWrapperProps}>
          {children}
        </Stack>
      </Card>
    </Stack>
  );
};
